import { Directive, ViewContainerRef } from '@angular/core';
/* 通过指令获取绑定视图 */
@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[ad-host]',
})
export class AdDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
